/**
 * PDF.js worker setup for react-pdf.
 * Import this once in src/index.js so Document/Page can load PDFs.
 */
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;
